module.exports = __webpack_public_path__ + "static/img/area.3a28616.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/area.png
// module id = EjFo
// module chunks = 0